import actionTypes from '../actionTypes';

export function requestMiniGames() {
  return {
    type: actionTypes.MINI_GAMES_REQUEST,
  };
}

export function successMiniGames(payload: any) {
  return {
    type: actionTypes.MINI_GAMES_SUCCESS,
    payload,
  };
}

export function failMiniGames(e: any) {
  return {
    type: actionTypes.MINI_GAMES_FAILURE,
    exception: e,
  };
}
